// Grid-view tile for a hosted site — same props as the list row so the page can swap layouts

import { FileCode } from 'lucide-react'
import { cn } from '../../lib/utils'
import { cardClass } from '../ui/styles'
import { DetailsToggle, SiteMeta, SiteStatusBadge, type HostedSiteRowProps } from './hosted-site-row'
import { SiteActions } from './site-actions'
import { SiteDisclosure } from './site-disclosure'
import { sitePublicUrl } from './utils'

export function HostedSiteCard({ site, expanded, onToggleExpanded, copied, onCopyLink, onPreview, onDelete, ...details }: HostedSiteRowProps) {
  return (
    <li className={cn(cardClass, 'flex flex-col p-4', expanded && 'sm:col-span-2 lg:col-span-3')}>
      <div className="mb-3 flex items-start justify-between gap-2">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-surface-muted">
          <FileCode className={cn('h-5 w-5', site.status === 'ready' ? 'text-accent-text' : 'text-fg-subtle')} aria-hidden="true" />
        </div>
        <SiteStatusBadge status={site.status} />
      </div>
      <p className="truncate text-sm font-semibold text-fg" title={site.filename}>
        {site.filename}
      </p>
      <SiteMeta site={site} className="mb-2" />
      {site.description && !expanded && <p className="mb-2 line-clamp-2 text-sm text-fg-muted">{site.description}</p>}
      {site.summary && !expanded && <p className="mb-2 line-clamp-2 text-xs text-fg-subtle">{site.summary}</p>}
      <div className="flex-1" />
      <div className="mt-2 flex items-center justify-between gap-1 border-t border-border pt-2">
        <DetailsToggle site={site} expanded={expanded} onToggle={() => onToggleExpanded(site.id)} />
        <SiteActions site={site} publicUrl={sitePublicUrl(site)} copied={copied} onCopyLink={onCopyLink} onPreview={onPreview} onDelete={onDelete} />
      </div>
      {expanded && <SiteDisclosure site={site} {...details} />}
    </li>
  )
}
